import axios from 'axios';

const api = axios.create({
  // baseURL: 'http://3.94.206.170:3333',
  // baseURL: 'http://127.0.0.1:3333',
  baseURL: 'https://trp-api.2bebot.com.br/',
});

export default api;
